<template>
  <div class="card large">
    <div class="card-image">
      <figure class="image">
        <img @click="changeToItemPage" :src="item.imageUrl" />
      </figure>
    </div>
    <div class="card-content">
      <p class="title is-4">{{item.name}}</p>
      <div class="content">
        <p>{{item.description}}</p>
      </div>
    </div>
    <footer class="card-footer">
      <a :href="item.downloadUrl" class="card-footer-item">Download</a>
    </footer>
  </div>
</template>

<script>
export default {
  methods: {
    changeToItemPage() {
      this.$router.push("/plugins/" + this.item._id);
    },
  },
  props: ["item"],
};
</script>